import { S3Handler } from "../utils/s3";
import {
    createEvent,
    createEventTicket,
    getAccountIdByHandler,
    getEventByHandler,
    getEventOrdersOfEvent,
    fetchEventTickets,
    getUserEventsOfEvent,
    updateEvent,
    updateEventTicket,
    getEventCoupons,
    getUtmsOfEvent,
    fetchEventTicketsSecure,
    getLinksOfEventsSecured,
    getLinksOfEventsByUtm,
    getOrderPrice
} from "../api";
import { isDateGreaterThanToday, isDateLessThanToday } from "../utils/minimal/formatTime";
import * as API from "../api";
import { FeeCollectionTypes } from "../consts/index.js";
import { ErrorService } from "./errorService.js";
import { i18n } from '../locales'
import { UserEventService } from './userEventService';


export const EventService = {
    async handleUpdateEventFlow(accountId, eventId, eventData, eventOriginalDesign) {
        const { event_main_photo, event_cover_photo, name, location, contact_email, event_handler, facebook_page, event_start_date, start_hour, end_hour, event_end_date, content, tickets, isSeatsEvent, feeCollectionType, is_manual_approve_buyer, facebook_pixel, google_analytics_id, embedded_html, maxCapacity, isWellnessEvent, trainer, type, isOnlyForMembers, font, fontUrl, titleFont, titleFontUrl, FAB_text, show_FAB, isBookable } = eventData

        if (event_main_photo?.shouldRenew && !event_main_photo.finalPath) {
            event_main_photo.finalPath = await S3Handler.uploadFile(event_main_photo)
        }

        if (event_cover_photo?.shouldRenew && !event_cover_photo.finalPath) {
            event_cover_photo.finalPath = await S3Handler.uploadFile(event_cover_photo)
        }

        const design = { image: event_main_photo.finalPath || event_main_photo.preview }
        const { colors } = getDesignColorsFromEventData(eventData)
        design.colors = colors

        design.imageWidth = event_main_photo.imageWidth ? event_main_photo.imageWidth : eventOriginalDesign.imageWidth
        design.imageHeight = event_main_photo.imageHeight ? event_main_photo.imageHeight : eventOriginalDesign.imageHeight

        if (event_cover_photo) {
            design.background = event_cover_photo.finalPath || event_cover_photo.preview
        }

        const eventDataToSend = {
            location,
            facebook_page,
            facebook_pixel,
            google_analytics_id,
            embedded_html,
            maxCapacity,
            contact_email,
            design,
            name,
            start_hour,
            end_hour,
            isSeatsEvent,
            feeCollectionType,
            is_manual_approve_buyer,
            handler: event_handler,
            description: content,
            start_date: event_start_date,
            end_date: event_end_date,
            type,
            isWellnessEvent,
            trainer,
            isOnlyForMembers,
            font,
            fontUrl,
            titleFont,
            titleFontUrl,
            FAB_text,
            show_FAB,
            isBookable,
        }

        const updatedEventResponse = await updateEvent({ accountId, eventId, eventData: eventDataToSend })
        let allTicketsResponse = []
        if (!isSeatsEvent) {
            const ticketsPromises = tickets.map((ticket) => {
                if (ticket.ticketId) {
                    const { ticketId } = ticket
                    delete ticket.ticketId
                    const ticketToUpdate = {
                        name: ticket.name,
                        quantity: ticket.quantity,
                        price: ticket.price,
                        countTicketsAllowPerPurchase: ticket.countTicketsAllowPerPurchase,
                        minTicketsAllowPerPurchase: ticket.minTicketsAllowPerPurchase || 0,
                        is_enabled: ticket.is_active,
                        start_date: ticket.active_from_date,
                        end_date: ticket.inactive_from_date,
                        order: ticket.order,
                    }
                    return updateEventTicket({ accountId, eventId, ticketId, ticketData: ticketToUpdate }).then(({ data }) => data)
                }
                const ticketDataToCreate = {
                    name: ticket.name,
                    quantity: ticket.quantity,
                    price: ticket.price,
                    is_enabled: ticket.is_active,
                    start_date: ticket.active_from_date,
                    end_date: ticket.inactive_from_date,
                    countTicketsAllowPerPurchase: ticket.countTicketsAllowPerPurchase,
                    minTicketsAllowPerPurchase: ticket.minTicketsAllowPerPurchase || 0,
                    description: "_",
                    currency: "ILS",
                    category: "party",
                    is_sold_out: false,
                    is_deleted: false,
                    is_hidden: false,
                    is_free: false,
                    is_recurring: false
                }
                return createEventTicket({ accountId, eventId, ticketData: ticketDataToCreate }).then(({ data }) => data)
            })
            allTicketsResponse = await Promise.all(ticketsPromises)
        }


        return {
            event: updatedEventResponse.data,
            tickets: allTicketsResponse
        }

    },
    async handleCreateEventFlow(accountId, sellerId, eventData) {
        if (!sellerId) {
            throw new Error('sellerId is not found')
        }

        const { event_main_photo, event_cover_photo, name, location, contact_email, event_handler, facebook_page, facebook_pixel, google_analytics_id, embedded_html, maxCapacity, event_start_date, start_hour, end_hour, event_end_date, content, tickets, isSeatsEvent, isAllowSeasonTicket, is_manual_approve_buyer, feeCollectionType, isWellnessEvent, trainer, type, isOnlyForMembers, font, fontUrl, titleFont, titleFontUrl, FAB_text, show_FAB, isBookable } = eventData

        if (!event_main_photo.finalPath) {
            event_main_photo.finalPath = await S3Handler.uploadFile(event_main_photo)
        }

        if (event_cover_photo && !event_cover_photo.finalPath) {
            event_cover_photo.finalPath = await S3Handler.uploadFile(event_cover_photo)
        }

        const { eventBackground, eventButtons, eventProgressBar, eventPrivacyPolicy } = eventData
        const design = { image: event_main_photo.finalPath, }

        const { colors } = getDesignColorsFromEventData(eventData)

        design.colors = colors

        if (event_main_photo.imageWidth) {
            design.imageWidth = event_main_photo.imageWidth
        }

        if (event_main_photo.imageHeight) {
            design.imageHeight = event_main_photo.imageHeight
        }

        if (event_cover_photo) {
            design.background = event_cover_photo.finalPath
        }

        const eventDataToSend = {
            name,
            location,
            facebook_page,
            facebook_pixel,
            google_analytics_id,
            embedded_html,
            maxCapacity,
            contact_email,
            design,
            start_hour,
            end_hour,
            isSeatsEvent,
            handler: event_handler,
            description: content,
            start_date: event_start_date,
            end_date: event_end_date,
            is_password_enabled: false,
            is_enabled: true,
            type,
            seller: sellerId,
            isAllowSeasonTicket,
            is_manual_approve_buyer,
            feeCollectionType,
            isWellnessEvent,
            trainer,
            isOnlyForMembers,
            font,
            fontUrl,
            titleFont,
            titleFontUrl,
            FAB_text,
            show_FAB,
            isBookable,
        }

        const newEventResponse = await createEvent({ accountId, eventData: eventDataToSend })

        let allTicketsResponse = []
        // if (!isSeatsEvent) {
        //     const promises = tickets.map(ticket => {
        //         const ticketData = {
        //             name: ticket.name,
        //             quantity: ticket.quantity,
        //             price: ticket.price,
        //             is_enabled: ticket.is_active,
        //             start_date: ticket.active_from_date,
        //             end_date: ticket.inactive_from_date,
        //             countTicketsAllowPerPurchase: ticket.countTicketsAllowPerPurchase,
        //             order: ticket.order,
        //             description: "_",
        //             currency: "ILS",
        //             category: "party",
        //             is_sold_out: false,
        //             is_deleted: false,
        //             is_hidden: false,
        //             is_free: false,
        //             is_recurring: false
        //         }
        //         return createEventTicket({ accountId, eventId: newEventResponse.data._id, ticketData })
        //     })
        //     allTicketsResponse = await Promise.all(promises)
        // }

        return {
            event: newEventResponse.data,
            tickets: allTicketsResponse.map(({ data }) => data)
        }
    },
    async handleDuplicateEventFlow(accountId, eventToDuplicate, duplicateEventHandlerName, duplicateEventName, duplicateEventStartDate) {

        const newEvent = {
            ...eventToDuplicate,
            name: duplicateEventName,
            handler: duplicateEventHandlerName,
            start_date: duplicateEventStartDate || eventToDuplicate.start_date,
            collaborates: [],
            links: []
        }

        delete newEvent._id
        delete newEvent.updatedAt
        delete newEvent.createdAt
        delete newEvent.seatsEventKey
        delete newEvent.seatsChartKey
        try {
            // time manipulations
            if (duplicateEventStartDate && eventToDuplicate.end_date) { // we want to the event time span to the new event so that the new event will be the same time span as the original event but not the same end_date
                const originalEventTimeSpan = new Date(eventToDuplicate.end_date) - new Date(eventToDuplicate.start_date)
                const newEventStartDate = new Date(duplicateEventStartDate)
                const newEventEndDate = new Date(newEventStartDate.getTime() + originalEventTimeSpan)
                newEvent.start_date = newEventStartDate
                newEvent.end_date = newEventEndDate
            }
            if (duplicateEventStartDate && eventToDuplicate.start_hour) {
                // start_hour is in the format of datetime object and so we want to extract the hour and store it on the new event
                newEvent.start_hour = new Date(duplicateEventStartDate)
                const hours = new Date(eventToDuplicate.start_hour).getHours()
                const minutes = new Date(eventToDuplicate.start_hour).getMinutes()
                newEvent.start_hour.setHours(hours, minutes)
            }

            if (duplicateEventStartDate && eventToDuplicate.end_hour) {
                newEvent.end_hour = new Date(duplicateEventStartDate)
                newEvent.end_hour.setHours(eventToDuplicate.end_hour.getHours(), eventToDuplicate.end_hour.getMinutes())
            }
        } catch (e) {
            console.error('duplicate event time manipulation failed')
            console.error(e.message)
        }

        const eventTicketsToDuplicate = await fetchEventTickets({ accountId, eventId: eventToDuplicate._id })

        const createdEventResponse = await createEvent({ accountId, eventData: newEvent })

        const promises = eventTicketsToDuplicate.data.map(ticket => {
            delete ticket._id
            ticket.event = newEvent._id
            return createEventTicket({ accountId, eventId: createdEventResponse.data._id, ticketData: ticket })
        })

        await Promise.all(promises)
        return createdEventResponse.data
    },
    async getEventPageData(accountHandler, eventHandler, utm) {

        const accountResponse = await getAccountIdByHandler(accountHandler)
        const accountId = accountResponse.data._id
        const eventResponse = await getEventByHandler({ accountId, eventHandler, utm })
        const eventTickets = await fetchEventTickets({ accountId, eventId: eventResponse.data._id, nimiFeeType: eventResponse.data.feeCollectionType === FeeCollectionTypes.ON_TOP_OF_TICKET ? FeeCollectionTypes.ON_TOP_OF_TICKET : null })

        let relevantLink
        if (utm) {
            try {
                const eventLinkResponse = await getLinksOfEventsByUtm({ accountId, eventId: eventResponse.data._id, utm })
                relevantLink = eventLinkResponse.data
            } catch (e) {
                ErrorService.handleError(e)
                console.log(e);
            }
        }

        return {
            eventData: eventResponse.data,
            accountData: accountResponse.data,
            ticketsData: eventTickets.data.filter(ticket => {

                const { is_enabled, start_date, end_date, _id } = ticket

                if (start_date && isDateGreaterThanToday(start_date)) {
                    return false
                }

                if (end_date && isDateLessThanToday(end_date)) {
                    return false
                }
                // ticket.countTicketsAllowPerPurchase = Math.min(ticket.countTicketsAllowPerPurchase, ticket.ticketsLeft) // TODO - check this after dan will fix it
                // if the event has a utm, we want to add special tickets to the event
                if (relevantLink && relevantLink.is_enabled) {
                    if (relevantLink.is_sold_out) {
                        return false
                    }
                    if (relevantLink.countTicketsAllowPerPurchase) {
                        ticket.countTicketsAllowPerPurchase = Math.min(ticket.countTicketsAllowPerPurchase, relevantLink.countTicketsAllowPerPurchase)
                    }
                    return relevantLink.tickets.includes(_id)
                }

                if (!is_enabled || is_enabled === 'false') {
                    return false
                }

                return true
            }),
            marketplaceData: accountResponse.data.marketPlace,
            linkData: relevantLink
        }

    },
    async getEventDashboardData({ accountId, eventId }) {

        const eventData = await Promise.all([
            getUserEventsOfEvent({ accountId, eventId }).then(({ data }) => data),
            getEventOrdersOfEvent({ accountId, eventId }).then(({ data }) => data),
            fetchEventTicketsSecure({ accountId, eventId }).then(({ data }) => data),
            getEventCoupons({ accountId, eventId }).then(({ data }) => data),
            getUtmsOfEvent({ accountId, eventId }).then(({ data }) => data),
            getLinksOfEventsSecured({ accountId, eventId }).then(({ data }) => data),
        ])

        const userEvents = eventData[0]
        const eventOrders = eventData[1]
        const tickets = eventData[2]
        const coupons = eventData[3]
        const utms = eventData[4]
        const links = eventData[5]

        return { userEvents, eventOrders, tickets, coupons, utms, links }

    },
    async updateOrCreateNimiTicketForSeatsIoTicket({ ticket, seatsIoTicketCategory, accountId, eventId, ticketQuantity, }) {
        if (ticket._id) {
            const ticketToUpdate = {
                name: seatsIoTicketCategory.label,
                price: ticket.price,
                quantity: ticketQuantity,
                seatsCategoryKey: seatsIoTicketCategory.key,
                seatsCategoryLabel: seatsIoTicketCategory.label,
                seatsCategoryColor: seatsIoTicketCategory.color,
                priceLevel: ticket.priceLevel,
            }
            return API.updateEventTicket({ accountId, eventId, ticketId: ticket._id, ticketData: ticketToUpdate })
        }

        const ticketDataToCreate = {
            name: seatsIoTicketCategory.label,
            price: ticket.price,
            seatsCategoryKey: seatsIoTicketCategory.key,
            seatsCategoryLabel: seatsIoTicketCategory.label,
            seatsCategoryColor: seatsIoTicketCategory.color,
            quantity: ticketQuantity,
            is_enabled: true,
            start_date: null,
            end_date: null,
            countTicketsAllowPerPurchase: ticket.countTicketsAllowPerPurchase,
            description: "Nimi representation for Seats.io tickets",
            currency: "ILS",
            category: "party",
            is_sold_out: false,
            is_deleted: false,
            is_hidden: false,
            is_free: false,
            is_recurring: false,
            priceLevel: ticket.priceLevel,
        }
        return API.createEventTicket({ accountId, eventId, ticketData: ticketDataToCreate })
    },
    async removeNimiTicketForSeatsIoTicket(ticket) {
        return API.deleteTicket({ accountId: ticket.account, eventId: ticket.event, ticketId: ticket._id })
    },

    async bookEvent({ seller, event, endUserSeasonTicket, endUser, selectedTimeSlot }) {
        const eventId = event._id;
        const accountId = event.account._id;
        const marketplaceId = seller.marketPlace._id;
        const endUserSeasonTicketId = endUserSeasonTicket._id;
        try {
            // 1. Fetch event tickets to get the ticket data needed for getPrice
            const { data: tickets } = await fetchEventTickets({ accountId, eventId });

            if (!tickets || tickets.length === 0) {
                throw new Error('No tickets found for this event');
            }

            // 2. Assume single ticket type for bookable events (user doesn't select specific tickets)
            const ticket = tickets[0]; // Get the first available ticket
            const ticketsIdsChosen = [ticket._id]; // Single ticket for booking

            // 3. Prepare order data for getPrice API call
            const orderData = {
                event: { _id: eventId }, // Event reference
                ticketsIdsChosen, // Array with single ticket ID
                endUserSeasonTicketId // User's subscription ID
            };

            // 4. Call getPrice to validate subscription and get pricing
            const { data: priceData } = await getOrderPrice({ accountId, orderData });

            // 5. If price is 0, proceed with actual booking
            if (priceData.finalPriceWithNimiFee === 0) {
                // UserEventService is already imported at the top of the file

                // 6. Prepare user event data for booking
                const userEventData = {
                    fname: endUser.fname || '',
                    lname: endUser.lname || '',
                    phone: endUser.phone || '',
                    email: endUser.email || '',
                    gender: endUser.gender || '',
                    birth_date: endUser.birth_date || null,
                    social_link: endUser.social_link || '',
                    ticketId: ticket._id,
                    isAllowMarketingDelivery: endUser.isAllowMarketingDelivery || false,
                    businessCode: endUser.businessCode || '',
                    businessName: endUser.businessName || '',
                    endUserSeasonTicketId,
                    // Add time slot information if available
                    ...(selectedTimeSlot && {
                        timeSlotId: selectedTimeSlot.id,
                        timeSlotDate: selectedTimeSlot.date,
                        timeSlotStartTime: selectedTimeSlot.startTime,
                        timeSlotEndTime: selectedTimeSlot.endTime
                    }),
                    ticketsInfo: [{
                        isApproved: false,
                        isCheckedIn: false,
                        isRefunded: false,
                        originalPrice: ticket.price,
                        ticket: ticket._id,
                        // Add time slot to ticket info as well
                        ...(selectedTimeSlot && {
                            timeSlotId: selectedTimeSlot.id,
                            timeSlotDate: selectedTimeSlot.date,
                            timeSlotStartTime: selectedTimeSlot.startTime,
                            timeSlotEndTime: selectedTimeSlot.endTime
                        })
                    }]
                };

                // 7. Create user event record
                const savedUserEvents = await UserEventService.createManyUserEvents({
                    accountId,
                    eventId,
                    allUserEvents: [{ userEvent: userEventData, ticketId: ticket._id }]
                });
                // 8. Create event order with FREE_TICKET
                const { data: eventOrder } = await UserEventService.createEventOrder({
                    accountId,
                    eventId,
                    purchaseToken: "FREE_TICKET",
                    userEvents: savedUserEvents,
                    seasonTicket: {
                        endUserSeasonTicket: { _id: endUserSeasonTicketId },
                        endUser: { _id: endUser._id }
                    },
                    seller: seller._id,
                    marketplaceId,
                });

                // 9. Return success with booking details
                return {
                    success: true,
                    priceData,
                    ticket,
                    ticketsIdsChosen,
                    canBookForFree: true,
                    userEvent: savedUserEvents[0],
                    eventOrder
                };
            }

            // 10. Return failure if not free
            return {
                success: false,
                priceData,
                ticket,
                ticketsIdsChosen,
                canBookForFree: false
            };

            // 

        } catch (error) {

            let errorMessage;
            try {
                errorMessage = JSON.parse(error.message).data.message.toLowerCase();

            } catch (error) {
                errorMessage = error.message.toLowerCase();
            }
            // Handle specific subscription validation errors
            if (errorMessage) {
                // Map error messages to user-friendly messages
                if (errorMessage.includes("already used for this event")) {
                    throw new Error('SUBSCRIPTION_ALREADY_USED_FOR_EVENT');
                }
                if (errorMessage.includes("season ticket not active or limit is reached")) {
                    throw new Error('SUBSCRIPTION_NOT_ACTIVE_OR_LIMIT_REACHED');
                }
                if (errorMessage.includes("end user season ticket limit reached for this event")) {
                    throw new Error('SUBSCRIPTION_EVENT_LIMIT_REACHED');
                }
                if (errorMessage.includes("end user season ticket limit reached")) {
                    throw new Error('SUBSCRIPTION_OVERALL_LIMIT_REACHED');
                }
                if (errorMessage.includes("end user season ticket not configured for this event")) {
                    throw new Error('SUBSCRIPTION_NOT_CONFIGURED_FOR_EVENT');
                }
            }

            // Re-throw the error for general handling
            throw error;
        }
    },
}

const getDesignColorsFromEventData = (eventData) => {
    const { eventBackground, eventButtons, eventProgressBar, eventPrivacyPolicy } = eventData
    return {
        colors: {
            background: eventBackground,
            buttons: eventButtons,
            progressBar: eventProgressBar,
            privacyPolicy: eventPrivacyPolicy
        }
    }
}

const mapDesignColorsToEventFrom = (design) => {
    const { colors = {} } = design
    const { background, buttons, progressBar, privacyPolicy } = colors
    return {
        eventBackground: background,
        eventButtons: buttons,
        eventProgressBar: progressBar,
        eventPrivacyPolicy: privacyPolicy
    }
}